<template>
  <article id="project-pagination">
    <span class="slate-bold">Pages</span>
    <input
      class="slate-bold"
      type="text"
      :value="actualPagesDisplay"
      @blur="isInputOnFocus = false"
      @focus="isInputOnFocus = true"
      @input="handleSetPage($event.target.value)"
    />
    <span class="text-grey-dark slate-bold">of {{ numberOfPages }}</span>
  </article>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "ProjectPagination",

  props: {
    numberOfPages: {
      type: Number,
    },
  },

  data() {
    return {
      isInputOnFocus: false,
    };
  },

  computed: {
    ...mapState("project", ["actualPage"]),
    ...mapGetters("project", ["onePageMode"]),

    actualPagesDisplay() {
      //The value of the input will the actual page when it's on focus
      if (this.isInputOnFocus) {
        return this.actualPage;
      } else {
        //But when it's not on focus, show a string with the actual pages (on double page mode)
        //Example: "1-2"
        if (this.onePageMode) {
          return this.actualPage;
        } else {
          return `${this.actualPage} - ${Number(this.actualPage) + 1}`;
        }
      }
    },
  },

  methods: {
    ...mapActions("project", ["setPage"]),

    handleSetPage(page) {
      console.log("number to setpage", Number(page));
      if (Number(page)) {
        if (Number(page) <= this.numberOfPages) {
          this.setPage(Number(page));
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#project-pagination {
  display: flex;
  align-items: center;
  grid-area: 2/1/3/-1;
  min-width: 100px;
  margin: auto;
  margin-top: 1rem;
  span {
    display: block !important;
    margin-right: 0.5rem;
  }
  input {
    width: 4rem;
    padding: 0.5rem 0.5rem 0.5rem .75rem;
    margin-right: 0.5rem;
    border-radius: 6px;
    border: 1px solid $grey-light;
  }
}
</style>
